const airportsPageActions = {
  SET_STATE: 'pages/airports/SET_STATE',
};

export default airportsPageActions;
